const NumberInput = ({ id, value, onChange }) => {
  return (
    <div className="input-group">
      <button type="button" className="input-group-text" onClick={() => onChange(Math.max(value - 1, 0))}>
        -
      </button>
      <input
        id={id}
        value={value}
        className="form-control"
        type="number"
        onChange={(event) => onChange(Math.max(parseInt(event.target.value, 10), 0))}
      />
      <button type="button" className="input-group-text" onClick={() => onChange(value + 1)}>
        +
      </button>
    </div>
  );
};

export default NumberInput;
